interface ListProps {
  list: Array<string>;
}

export const OrderedList = ({ list }: ListProps): JSX.Element => {
  return (
    <ol className="font-medium text-font-200 text-s-20 sm:text-base list-decimal pl-6">
      {list.map((item) => (
        <li className="py-2" key={item}>
          {item}
        </li>
      ))}
    </ol>
  );
};
